import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';
import PspUser from './PspUser';

export default class PspUsers extends React.Component {
  renderLinkedUsers(linkedUsers) {
    console.log(linkedUsers,"linkedUsersdetails")
    if (isEmpty(linkedUsers)) return null;

    return (
      <div>
        {linkedUsers.map(user => {
          return (
            <PspUser
              user={cloneDeep(user)}
              deleteProviderLinkedUserFunc={this.props.deleteProviderLinkedUserFunc}
              provider={this.props.provider}
            />
          );
        })}
      </div>
    );
  }

  render() {
    const { users } = this.props;

    return <div>{this.renderLinkedUsers(users)}</div>;
  }
}
